import * as React from "react";

const AllRequestsSVG = ({
    color = "#F8FAFC"
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill={color}
            d="M16.058 25.75q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V12.558q0-.758.525-1.283t1.283-.525h11.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm-3.5 3.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V14.558h1.5v12.884q0 .116.096.212a.3.3 0 0 0 .212.096h12.884v1.5zm8.577-13.48h6.615v-3.212a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096h-6.307z"
        ></path>
    </svg>
);

export default AllRequestsSVG;
